/**
 * Current fencing season according to USA Fencing. Based on the fall (so the 2023-2024 season would be represented as 2023)
 */
export const CURRENT_SEASON_NUM = new Date().getMonth() >= 7 ? new Date().getFullYear() : new Date().getFullYear() - 1;

/**
 * Current fencing season according to USA Fencing. Formatted as a string (e.g. `2024-2025`)
 */
export const CURRENT_SEASON_STR = `${CURRENT_SEASON_NUM}-${CURRENT_SEASON_NUM + 1}`;

/**
 * Last fencing season according to USA Fencing. Formatted as a string (e.g. `2023-2024`)
 */
export const LAST_SEASON_STR = `${CURRENT_SEASON_NUM - 1}-${CURRENT_SEASON_NUM}`;

/**
 * Calculate the roster deadline for a given season
 * The deadline is the Friday before December 24th of the season year
 * @param season Season string in format "YYYY-YYYY" (e.g. "2024-2025")
 * @returns Date object representing the deadline (end of day)
 */
export const getRosterDeadline = (season: string): Date => {
    const year = Number(season.split("-")[0]);

    // December 24th of the season year
    const december24 = new Date(year, 11, 24); // Month is 0-indexed, so 11 = December

    // Find the Friday before December 24th
    const dayOfWeek = december24.getDay(); // 0 = Sunday, 5 = Friday
    const daysToSubtract = dayOfWeek === 5 ? 0 : dayOfWeek < 5 ? dayOfWeek + 2 : dayOfWeek - 5;

    const deadline = new Date(year, 11, 24 - daysToSubtract);
    deadline.setHours(23, 59, 59, 999); // End of day

    return deadline;
};

/**
 * Check if the roster deadline has passed for a given season
 * @param season Season string in format "YYYY-YYYY" (e.g. "2024-2025")
 * @returns boolean indicating if the deadline has passed
 */
export const isRosterDeadlinePassed = (season: string): boolean => {
    const deadline = getRosterDeadline(season);
    return new Date() > deadline;
};

/**
 * Generate a list of season options until the current season. Formatted as strings (e.g. `["2023-2024"]`)
 * @param start Number corresponding to the start season. Based on the fall (so the 2023-2024 season would be represented as 2023)
 */
export const getSeasonOptions = (start = 2023): string[] => {
    const currentSeason = new Date().getMonth() >= 7 ? new Date().getFullYear() : new Date().getFullYear() - 1;
    const seasons: string[] = [];
    for (let i = 0; i < 10; i++) {
        // No tolerating monkey business
        const season = currentSeason - i;
        seasons.unshift(`${season}-${season + 1}`);
        if (season === start) break;
    }
    return seasons;
};
